<template>
    <div id="news">
        <v-container>
            <h1 class="page-title mouse-hover hover-invert">News</h1>
            <div class="news-content">
                <v-row align="start">
                    <!-- Left: AIF 2025 -->
                    <v-col cols="12" md="6">
                        <div class="news-card">
                            <p class="news-meta mouse-hover hover-invert">11 Νοεμβρίου 2025 · Μέγαρο Μουσικής Αθηνών</p>
                            <h2 class="news-event mouse-hover hover-invert">Athens Investment Forum 2025</h2>
                            <h3 class="news-title mouse-hover hover-invert">
                                Η Scrufy στο 8ο Athens Investment Forum 2025
                            </h3>
                            <p class="news-subtitle mouse-hover hover-invert">
                                Παρουσίαση του έργου BlueBOT στη μεγαλύτερη ετήσια διοργάνωση για τις επενδύσεις και την ανάπτυξη στην Ελλάδα
                            </p>
                            <div class="news-body">
                                <p class="mouse-hover hover-invert">
                                    Η Scrufy συμμετείχε στο 8ο Athens Investment Forum (AIF 2025), το ετήσιο συνέδριο-σταθμό για τις επενδύσεις και την ανάπτυξη στην Ελλάδα, που πραγματοποιήθηκε στις 11 Νοεμβρίου 2025 στο Μέγαρο Μουσικής Αθηνών. Στόχος της παρουσίας της εταιρείας ήταν η προώθηση του καινοτόμου ερευνητικού έργου BlueBOT — ενός υποβρύχιου ρομπότ για την αποτροπή ανάπτυξης βιορρύπανσης σε υποθαλάσσιες υποδομές.
                                </p>
                                <h3 class="section-heading mouse-hover hover-invert">Σχετικά με το AIF 2025</h3>
                                <p class="mouse-hover hover-invert">
                                    Το Athens Investment Forum αποτελεί κορυφαία διοργάνωση για το επιχειρηματικό και επενδυτικό οικοσύστημα της χώρας, συγκεντρώνοντας θεσμικούς παράγοντες, επενδυτές, εκπροσώπους της πολιτικής ηγεσίας και στελέχη επιχειρήσεων. Η φετινή διοργάνωση εστίασε σε τρεις βασικούς θεματικούς άξονες:
                                </p>
                                <ul class="news-list mouse-hover hover-invert">
                                    <li>Ανάπτυξη &amp; Επενδύσεις</li>
                                    <li>Υποδομές &amp; Κατασκευές</li>
                                    <li>Ενέργεια &amp; Ψηφιακός Μετασχηματισμός</li>
                                </ul>
                                <h3 class="section-heading mouse-hover hover-invert">Η συμμετοχή της Scrufy</h3>
                                <p class="mouse-hover hover-invert">
                                    Η Scrufy παρουσίασε στους συμμετέχοντες το έργο BlueBOT (κωδικός έργου 113750), μια καινοτόμο λύση για την αποτροπή ανάπτυξης βιορρύπανσης στο κύτος των πλοίων, η οποία εξασφαλίζει βέλτιστη ενεργειακή απόδοση ανεξάρτητα από το προφίλ λειτουργίας του σκάφους. Πρόκειται για ένα υποβρύχιο ερπυστριοφόρο ρομπότ που κινείται σε επαφή με το κύτος μέσω ελαστομερών ιμάντων και ισχυρών μόνιμων μαγνητών, με δυνατότητα τόσο αυτόνομης λειτουργίας, ακολουθώντας τη βέλτιστη διαδρομή χάρη στο προηγμένο λογισμικό πλοήγησης, όσο και απομακρυσμένου χειρισμού από χρήστη.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Η τεχνολογία του BlueBOT απευθύνεται άμεσα σε ένα διαχρονικό πρόβλημα της ναυτιλίας: η συσσώρευση βιορρύπανσης στις γάστρες αυξάνει την τριβή, εκτοξεύει την κατανάλωση καυσίμων και τις εκπομπές ρύπων, και δημιουργεί υψηλά κόστη συντήρησης. Η λύση της Scrufy απαντά σε αυτές τις προκλήσεις προληπτικά και με μειωμένο περιβαλλοντικό αποτύπωμα σε σύγκριση με τις παραδοσιακές μεθόδους καθαρισμού.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Η παρουσία της Scrufy στο AIF 2025 ενίσχυσε τη δικτύωση με επενδυτές και στρατηγικούς συνεργάτες από τους τομείς της ενέργειας, των υποδομών και του ψηφιακού μετασχηματισμού, πεδία στα οποία η τεχνολογία του BlueBOT έχει άμεση εφαρμογή.
                                </p>
                                <h3 class="section-heading mouse-hover hover-invert">Σχετικά με το έργο</h3>
                                <p class="mouse-hover hover-invert">
                                    Το έργο «Υποβρύχιο ρομπότ για την αποτροπή ανάπτυξης βιορρύπανσης» (Ακρωνύμιο: BlueBOT, κωδικός 113750) αποτελεί ένα από τα κύρια ερευνητικά και αναπτυξιακά έργα της Scrufy. Περισσότερες πληροφορίες: <a href="https://scrufy.co/bluebot" target="_blank" class="mouse-hover hover-invert">scrufy.co/bluebot</a>
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Το έργο υλοποιείται στο πλαίσιο του προγράμματος «Ανάπτυξη Ψηφιακών Προϊόντων και Υπηρεσιών» του Εθνικού Σχεδίου Ανάκαμψης και Ανθεκτικότητας «Ελλάδα 2.0» με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης – NextGenerationEU.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Επίσημη διαδικτυακή πύλη της δράσης: <a href="https://digitalsme.gov.gr" target="_blank" class="mouse-hover hover-invert">digitalsme.gov.gr</a>
                                </p>
                            </div>
                        </div>
                    </v-col>

                    <!-- Right: Invest in Greece Summit 2026 -->
                    <v-col cols="12" md="6">
                        <div class="news-card">
                            <p class="news-meta mouse-hover hover-invert">12 Μαρτίου 2026 · Μέγαρο Μουσικής Αθηνών</p>
                            <h2 class="news-event mouse-hover hover-invert">Invest in Greece Summit 2026</h2>
                            <h3 class="news-title mouse-hover hover-invert">
                                Η Scrufy στο Invest in Greece Summit 2026
                            </h3>
                            <p class="news-subtitle mouse-hover hover-invert">
                                Το BlueBOT στη σύνοδο κορυφής για μια ανταγωνιστική και βιώσιμη ελληνική οικονομία
                            </p>
                            <div class="news-body">
                                <p class="mouse-hover hover-invert">
                                    Η Scrufy έδωσε το παρών στο Invest in Greece Summit 2026, με τίτλο «Χτίζοντας μια ανταγωνιστική και βιώσιμη οικονομία», που πραγματοποιήθηκε στις 12 Μαρτίου 2026 στο Μέγαρο Μουσικής Αθηνών. Η εταιρεία βρέθηκε στη διοργάνωση με σκοπό την προβολή του έργου BlueBOT, ενός υποβρύχιου ρομπότ που αναπτύσσεται για την αποτροπή της βιορρύπανσης στο κύτος των πλοίων.
                                </p>
                                <h3 class="section-heading mouse-hover hover-invert">Η διοργάνωση</h3>
                                <p class="mouse-hover hover-invert">
                                    Το Invest in Greece Summit, που διοργανώθηκε από το Moneyreview.gr σε συνεργασία με τη Νομική Βιβλιοθήκη, αποτελεί μια από τις πιο σημαντικές πλατφόρμες διαλόγου στη χώρα για το επενδυτικό περιβάλλον και τη βιώσιμη ανάπτυξη. Φέτος, η συζήτηση επικεντρώθηκε στο πώς η νομική ασφάλεια, η ορθή πολιτική και οι υπεύθυνες επενδύσεις μπορούν να οδηγήσουν την Ελλάδα σε ένα βιώσιμο μέλλον, καθώς και στα χρηματοδοτικά εργαλεία και τις στρατηγικές προτεραιότητες που διαμορφώνουν τη βιώσιμη ανάπτυξη.
                                </p>
                                <h3 class="section-heading mouse-hover hover-invert">Η συμμετοχή της Scrufy</h3>
                                <p class="mouse-hover hover-invert">
                                    Η θεματολογία της συνόδου συνδέεται άμεσα με τη φιλοσοφία του BlueBOT. Το έργο (κωδικός 113750) αποτελεί ένα χαρακτηριστικό παράδειγμα υπεύθυνης και τεχνολογικά καινοτόμας επένδυσης: συνδυάζει τη ρομποτική με την τεχνητή νοημοσύνη και το περιβαλλοντικό όφελος, προσφέροντας μια καθαρή λύση σε ένα δαπανηρό και ρυπογόνο πρόβλημα της ναυτιλιακής βιομηχανίας.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Πέρα από τον προληπτικό καθαρισμό του κύτους, το BlueBOT ενσωματώνει αλγορίθμους τεχνητής νοημοσύνης για την αναγνώριση της βιορρύπανσης, επιτρέποντας την αυτοματοποιημένη ποσοτικοποίησή της, τη δημιουργία αναφορών και τη χαρτογράφηση του κύτους, στοιχεία αξιοποιήσιμα τόσο για τις αρχές όσο και για τους πλοιοκτήτες. Η πλήρης βιντεοσκόπηση της διαδικασίας καθαρισμού προσθέτει διαφάνεια και ιχνηλασιμότητα, χαρακτηριστικά που έχουν αυξανόμενη βαρύτητα σε ένα ρυθμιστικό περιβάλλον που κινείται προς αυστηρότερα κριτήρια βιωσιμότητας.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Η παρουσίαση του BlueBOT σε ένα κοινό από επενδυτές, θεσμικούς φορείς και στελέχη της αγοράς ενίσχυσε τη δικτύωση της εταιρείας και άνοιξε νέες προοπτικές συνεργασιών για την επόμενη φάση ανάπτυξης του έργου.
                                </p>
                                <h3 class="section-heading mouse-hover hover-invert">Σχετικά με το έργο</h3>
                                <p class="mouse-hover hover-invert">
                                    Το έργο υλοποιείται στο πλαίσιο του προγράμματος «Ανάπτυξη Ψηφιακών Προϊόντων και Υπηρεσιών» του Εθνικού Σχεδίου Ανάκαμψης και Ανθεκτικότητας «Ελλάδα 2.0» με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης – NextGenerationEU.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Επίσημη διαδικτυακή πύλη της δράσης: <a href="https://digitalsme.gov.gr" target="_blank" class="mouse-hover hover-invert">digitalsme.gov.gr</a>
                                </p>
                            </div>

                            <v-carousel
                                class="news-slider"
                                height="360"
                                hide-delimiter-background
                                show-arrows="hover"
                            >
                                <v-carousel-item
                                    v-for="(img, i) in summitImages"
                                    :key="i"
                                    :src="img"
                                    contain
                                />
                            </v-carousel>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<style scoped>
#news {
    padding-top: var(--abh);
    background: rgba(7, 28, 52, 0.8);
    min-height: calc(var(--vh, 1vh) * 100);
}

.news-content {
    padding: 2rem 0;
}

.news-card {
    background: rgba(32, 92, 242, 0.05);
    border: 1px solid rgba(32, 92, 242, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin: 2rem 0;
    height: 100%;
    overflow: hidden;
}

.news-event {
    color: var(--v-primary-base);
    margin-bottom: 0.5rem;
    line-height: 1.2;
}

.news-meta {
    color: var(--v-primary-base);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 0.75rem;
}

.news-title {
    color: #ECEAEA;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    line-height: 1.4;
}

.news-subtitle {
    color: #ECEAEA;
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(32, 92, 242, 0.2);
    opacity: 0.85;
}

.news-body p {
    color: #ECEAEA;
    margin-bottom: 1rem;
    text-align: justify;
    line-height: 1.6;
}

.news-body a {
    color: var(--v-primary-base, #205CF2) !important;
    font-size: inherit !important;
    font-weight: inherit !important;
}

.section-heading {
    color: var(--v-primary-base);
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin: 1.5rem 0 0.75rem;
}

.news-list {
    color: #ECEAEA;
    padding-left: 1.2rem;
    margin-bottom: 1rem;
    line-height: 1.8;
}

.news-slider {
    overflow: hidden;
    margin: 1.5rem auto 0;
    border: 1px solid rgba(32, 92, 242, 0.2);
    border-radius: 10px;
}

.news-slider ::v-deep .v-image__image {
    background-position: center center !important;
    background-size: contain !important;
}

.news-slider ::v-deep .v-window__prev .v-icon,
.news-slider ::v-deep .v-window__next .v-icon {
    font-size: 1rem !important;
}

@media screen and (max-width: 960px) {
    .news-card {
        padding: 1.5rem;
        margin: 1rem 0;
    }

    .news-body p {
        text-align: left;
    }
}
</style>

<script>
export default {
    name: 'News',
    data() {
        return {
            summitImages: [
                '/assets/news/nextEraGreece.jpeg',
                '/assets/news/aperion.jpeg'
            ]
        }
    },
    mounted() {
        this.$store.state.app_bar_visible = true;
    }
}
</script>
